import { useEffect } from 'react'
import { useAuth } from '@praxis/component-auth'
import { useAnalytics } from '@praxis/analytics/client'
import { logEvent } from '@praxis/component-logging'
import { Card, Grid, Layout } from '@enterprise-ui/canvas-ui-react'
import { SectionHeader } from '../globalComponents/SectionHeader'
import { useRouteError } from 'react-router'
import apiConfig from '../globalConfig/apiConfig'
import {
  CUSTOM_ANALYTICS_TYPES,
  CUSTOM_ANALYTICS_EVENT_NAMES,
} from '../globalConfig/constants'

export const ErrorContent = () => {
  const auth = useAuth()
  const userLanId = auth?.session?.userInfo?.lanId
  const error = useRouteError()
  const { sendEvent } = useAnalytics()

  useEffect(() => {
    logEvent(
      {
        message:
          auth?.session?.userInfo?.fullName +
          ' (' +
          auth?.session?.userInfo?.lanId +
          ') encountered the following error: ' +
          error?.message,
      },
      apiConfig.logging,
    )

    sendEvent({
      event: {
        type: CUSTOM_ANALYTICS_TYPES.ERROR,
        id: CUSTOM_ANALYTICS_EVENT_NAMES.UNEXPECTED_ERROR,
        value: error?.message,
      },
      client: {
        employee_login_id: userLanId,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    auth?.session?.userInfo?.fullName,
    auth?.session?.userInfo?.lanId,
    error.message,
  ])

  return (
    <>
      <SectionHeader
        className="hesp-sectionHeader-layout"
        pageHeading="Error"
      />
      <Layout.Body
        className="hesp-generic-layout"
        data-testid="layoutWithErrorContent"
        includeRail
      >
        <Card className="hc-pa-normal">
          <Grid.Container>
            <Grid.Item className="hesp-general-fullwidth">
              <p>Oops! We encountered the following error: {error.message}</p>
            </Grid.Item>
          </Grid.Container>
        </Card>
      </Layout.Body>
    </>
  )
}
